import { Text, Button, toast } from "@jsq/ds/core";
import { client } from "~/apollo/client";
import { useCancelAssignmentMutation } from "~/graphql/supergraphHooks";
import { SPACING } from "~/styles/variables";

type Props = {
  assignee?: string | undefined;
  assigneeRole: "maker" | "checker" | undefined;
  caseId: number;
};

const UnassignControls = ({ assignee, caseId }: Props) => {
  const [cancelAssignment, { loading }] = useCancelAssignmentMutation({
    refetchQueries: ["GetComplianceCase", "GetComplianceCaseAuditLogs"],
    onCompleted: async () => {
      toast.success("Case unassigned successfully");
      await client.refetchQueries({
        include: "active",
      });
    },
    onError: (e) => toast.error(e.message),
  });
  return (
    <Text variant="secondary-md" style={{ margin: `${SPACING.X_SMALL} ${SPACING.LARGE}` }}>
      Assigned to{" "}
      <Text variant="strong-md" asSpan>
        {assignee}
      </Text>
      <Button
        variant="neutral"
        css={{ margin: `${SPACING.X_SMALL} ${SPACING.SMALL}` }}
        isInline
        onClick={() => void cancelAssignment({ variables: { caseId: caseId } })}
        disabled={loading}
      >
        Cancel assignment
      </Button>
    </Text>
  );
};

export default UnassignControls;
